import * as React from "react";
import './Icon.scss';
import ReactSVG from 'react-svg'

// @ts-ignore
import clock from "../../assets/Icons/clock.svg";
// @ts-ignore
import alertTriangle from "../../assets/Icons/alert-triangle.svg";
// @ts-ignore
import home from "../../assets/Icons/home.svg";
// @ts-ignore
import users from "../../assets/Icons/users.svg";
// @ts-ignore
import pin from "../../assets/Icons/map-pin.svg";
// @ts-ignore
import message from "../../assets/Icons/message-square.svg";
// @ts-ignore
import star from "../../assets/Icons/star.svg";
// @ts-ignore
import creditCard from "../../assets/Icons/credit-card.svg";
// @ts-ignore
import mail from "../../assets/Icons/mail1.svg";
// @ts-ignore
import chart from "../../assets/Icons/chart2.svg";
// @ts-ignore
import trash from "../../assets/Icons/trash.svg";
// @ts-ignore
import edit from "../../assets/Icons/edit2.svg";
// @ts-ignore
import check from "../../assets/Icons/check-square.svg";
// @ts-ignore
import wallet from "../../assets/Icons/wallet.svg";
// @ts-ignore
import signOut from "../../assets/Icons/sign-out.svg";
// @ts-ignore
import alertTriangleRed from "../../assets/Icons/alert-triangle_red.svg";
// @ts-ignore
import hamburger from "../../assets/Icons/menu-hamburger.svg";
// @ts-ignore
import close from "../../assets/Icons/close-icon-white.svg";
// @ts-ignore
import closeBlack from "../../assets/Icons/close-icon-black.svg";
// @ts-ignore
import connected from "../../assets/Icons/oval-connected.svg";
// @ts-ignore
import disconnected from "../../assets/Icons/oval-diconnected.svg";
// @ts-ignore
import blueArrowDown from "../../assets/Icons/blue-arrow-down.svg";
// @ts-ignore
import greyArrowDown from "../../assets/Icons/grey-arrow-down.svg";
// @ts-ignore
import blueArrowUp from "../../assets/Icons/blue-arrow-up.svg";
// @ts-ignore
import stepBigEmpty from "../../assets/Icons/step-big-blank.svg";
// @ts-ignore
import stepBigFull from "../../assets/Icons/step-big-full.svg";
// @ts-ignore
import stepBigFinished from "../../assets/Icons/finished-step-big.svg";
// @ts-ignore
import stepSmallEmpty from "../../assets/Icons/step-small-blank.svg";
// @ts-ignore
import stepSmallFull from "../../assets/Icons/step-small-full.svg";
// @ts-ignore
import stepBigEmptyMobile from "../../assets/Icons/step-big-blank-mobile.svg";
// @ts-ignore
import stepBigFullMobile from "../../assets/Icons/step-big-full-mobile.svg";
// @ts-ignore
import stepSmallEmptyMobile from "../../assets/Icons/step-small-blank-mobile.svg";
// @ts-ignore
import stepSmallFullMobile from "../../assets/Icons/step-small-full-mobile.svg";
// @ts-ignore
import browse from "../../assets/Icons/browse-icon.svg";
// @ts-ignore
import loading from "../../assets/Icons/loading.svg";
// @ts-ignore
import pdf from "../../assets/Icons/pdf-icon.svg";
// @ts-ignore
import error from "../../assets/Icons/error.svg";
// @ts-ignore
import bell from "../../assets/Icons/bell.svg";
// @ts-ignore
import security from "../../assets/Icons/security.svg";
// @ts-ignore
import exitBtn from "../../assets/Icons/exit-btn.svg";
// @ts-ignore
import completed from "../../assets/Icons/completed.svg";
// @ts-ignore
import chevronRight from "../../assets/Icons/chevron-right.svg";
// @ts-ignore
import spinnerLoader from "../../assets/Icons/spinner.svg";
// @ts-ignore
import backArrow from "../../assets/Icons/back-arrow.svg";
// @ts-ignore
import backArrowBlack from "../../assets/Icons/back-arrow-black.svg";
// @ts-ignore
import calendar from "../../assets/Icons/calendar.svg";
// @ts-ignore
import greenCheckmark from "../../assets/Icons/greenCheckmark.svg";
// @ts-ignore
import radio from "../../assets/Icons/radio.svg";
// @ts-ignore
import tooltip from "../../assets/Icons/tooltip.svg";
// @ts-ignore
import radioSelected from "../../assets/Icons/radio-selected.svg";
// @ts-ignore
import settings from "../../assets/Icons/settings.svg";
// @ts-ignore
import calculator from "../../assets/Icons/calculator.svg";
// @ts-ignore
import checkedCheckbox from "../../assets/Icons/check-box-checked.svg";
// @ts-ignore
import checkbox from "../../assets/Icons/check-box.svg";
// @ts-ignore
import done from "../../assets/Icons/done-icon.svg";

const icons = {clock, home, users, pin, message, star, creditCard, mail, alertTriangle, alertTriangleRed, chart, check, edit, trash, wallet,
    signOut, close, closeBlack, hamburger, connected, disconnected, blueArrowDown, blueArrowUp, greyArrowDown, stepBigEmpty, stepBigFinished, stepBigFull, stepSmallEmpty, stepSmallFull,stepBigEmptyMobile, stepBigFullMobile, stepSmallEmptyMobile, stepSmallFullMobile,
    browse, loading, pdf, error, bell, security, exitBtn, completed, chevronRight, spinnerLoader, backArrow, backArrowBlack, calendar, greenCheckmark, radio, radioSelected, tooltip, settings, calculator, checkbox, checkedCheckbox,
    done};

const Icon = (props: any ) => {
    return<>
        <ReactSVG src={icons[props.icon]}/>
    </>
};

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon/Icon.tsx